import { render } from "./UiRowActions.vue?vue&type=template&id=d48b00f2&ts=true"
import script from "./UiRowActions.vue?vue&type=script&lang=ts"
export * from "./UiRowActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__